import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-048a2146")
const _hoisted_1 = { class: "payment_success" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-error p-text-center" }, "Pagamento annullato", -1)
const _hoisted_3 = { class: "p-text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Il pagamento è stato annullato.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Non le verrà addebbitato alcun importo.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Puoi provvedere al pagamento dell'ordine in un secondo momento dalla pagina dedicata. ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderPostPaymentActions = _resolveComponent("OrderPostPaymentActions")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "mp_card" }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_OrderPostPaymentActions, { orderId: _ctx.orderId }, null, 8, ["orderId"])
        ])
      ]),
      _: 1
    })
  ]))
}